export type NavItem = {
  label: string
  href: string
  description: string
  badge?: string
}

export type NavGroup = { heading?: string; items: NavItem[] }

export type NavMenu = {
  label: string
  /** Direct link (no dropdown) when set. */
  href?: string
  groups?: NavGroup[]
  width?: string
  align?: 'left' | 'right'
}

export const mainMenu: NavMenu[] = [
  {
    label: 'Solutions',
    width: 'w-80',
    groups: [
      {
        items: [
          {
            label: 'Solutions Overview',
            href: '/solutions',
            description: 'How SyNeural is used in research, education, work & government',
          },
          {
            label: 'SKP — Connected Knowledge',
            href: '/semantic-knowledge',
            description: 'Organize research and sources into searchable, connected knowledge',
          },
          {
            label: 'Noetivra — Interactive Workspace',
            href: '/noetivra',
            badge: 'Coming soon',
            description: 'Explore knowledge, complete assessments & review findings',
          },
        ],
      },
    ],
  },
  { label: 'Human Capability', href: '/human-capability' },
  {
    label: 'Research',
    width: 'w-80',
    groups: [
      {
        items: [
          {
            label: 'Research Overview',
            href: '/research',
            description: 'The questions and priorities behind our work',
          },
          {
            label: 'Papers & Publications',
            href: '/roadmap#publications',
            description: 'White papers, concept notes & research directions',
          },
          {
            label: 'Cognocracy — Civic Governance Concept',
            href: '/initiatives/cognocracy',
            description: 'A proposed framework, presented for research and discussion',
          },
        ],
      },
    ],
  },
  {
    label: 'About',
    width: 'w-72',
    align: 'right',
    groups: [
      {
        items: [
          { label: 'About SyNeural', href: '/about', description: 'Our mission, vision & leadership' },
          { label: 'Partnerships', href: '/partnerships', description: 'Work with us on pilots and research' },
          { label: 'Investors', href: '/investors', description: 'The opportunity & business model' },
        ],
      },
    ],
  },
]

export type FooterLink = { label: string; href: string; nested: boolean }

export const footerColumns: { heading: string; links: FooterLink[] }[] = [
  {
    heading: 'Solutions',
    links: [
      { label: 'Solutions Overview', href: '/solutions', nested: false },
      { label: 'SKP — Connected Knowledge', href: '/semantic-knowledge', nested: false },
      { label: 'Noetivra — Coming soon', href: '/noetivra', nested: false },
      { label: 'Education', href: '/education', nested: false },
      { label: 'Employers', href: '/employers', nested: false },
      { label: 'Civil Society', href: '/civil-society', nested: false },
      { label: 'Government', href: '/government', nested: false },
      { label: 'Leadership', href: '/leadership', nested: false },
    ],
  },
  {
    heading: 'Human Capability',
    links: [
      { label: 'Human Capability Framework', href: '/human-capability', nested: false },
      { label: 'CJI', href: '/cji', nested: true },
      { label: 'NCJI', href: '/ncji', nested: true },
    ],
  },
  {
    heading: 'Research',
    links: [
      { label: 'Research Overview', href: '/research', nested: false },
      { label: 'Papers & Publications', href: '/roadmap#publications', nested: false },
      { label: 'Roadmap', href: '/roadmap', nested: false },
      { label: 'Cognocracy', href: '/initiatives/cognocracy', nested: false },
    ],
  },
  {
    heading: 'About',
    links: [
      { label: 'About SyNeural', href: '/about', nested: false },
      { label: 'Partnerships', href: '/partnerships', nested: false },
      { label: 'Investors', href: '/investors', nested: false },
      { label: 'Contact Us', href: '/contact', nested: false },
    ],
  },
]
